import { PERFECT_PERSONALITY_OPTIONS } from '../PERFECT_PERSONALITY_OPTIONS';
import { PerfectPersonalityOptionIdType } from '../types';

const DEFAULT_ID: PerfectPersonalityOptionIdType = 'sweet';
const DEFAULT_TITLE = PERFECT_PERSONALITY_OPTIONS[4].title; // sweet option

export const getPerfectPersonalityChoiceIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): PerfectPersonalityOptionIdType | null => {
  const id = PERFECT_PERSONALITY_OPTIONS.find(
    (option) => option.title === title,
  )?.id;

  if (id) {
    return id;
  }

  if (withDefault) {
    return DEFAULT_ID;
  }

  return null;
};

export const getPerfectPersonalityChoiceTitleById = (
  id: PerfectPersonalityOptionIdType | null | undefined,
  withDefault = false,
): string | null => {
  const title = PERFECT_PERSONALITY_OPTIONS.find(
    (option) => option.id === id,
  )?.title;

  if (title) {
    return title;
  }

  if (withDefault) {
    return DEFAULT_TITLE;
  }

  return null;
};
